import { render, staticRenderFns } from "./bonus-menu-item.vue?vue&type=template&id=674e95ec&"
import script from "./bonus-menu-item.vue?vue&type=script&lang=ts&"
export * from "./bonus-menu-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_wzvh6gi4tchptuexh7cjhim74e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports